import { render, staticRenderFns } from "./OfficalItem.vue?vue&type=template&id=b6a6275c&scoped=true"
import script from "./OfficalItem.vue?vue&type=script&lang=js"
export * from "./OfficalItem.vue?vue&type=script&lang=js"
import style0 from "./OfficalItem.vue?vue&type=style&index=0&id=b6a6275c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a6275c",
  null
  
)

export default component.exports